import { EstimateResponse } from '@/types/estimates/EstimateResponse';
import { shouldHideAgencyFlexibilityContent } from './shouldHideAgencyFlexibilityContent';

type ResolveEstimateDisplayTitleInput = {
  estimateName?: string | null;
  circuitName: string;
  showQuoteName?: boolean;
  allowAgencyModification?: boolean;
  viewContext?: EstimateResponse['viewContext'];
};

/** Title shown next to the estimate ref in headers and side cards. */
export const resolveEstimateDisplayTitle = ({
  estimateName,
  circuitName,
  showQuoteName,
  allowAgencyModification,
  viewContext,
}: ResolveEstimateDisplayTitleInput): string => {
  if (
    allowAgencyModification &&
    shouldHideAgencyFlexibilityContent(
      {
        allowAgencyModification,
        viewContext,
        showQuoteName,
        showSummaryAndImportantPoints: true,
        showPriceIncludesExcludes: true,
        showModificationCancellationConditions: true,
      },
      'showQuoteName',
    )
  ) {
    return '';
  }
  if (allowAgencyModification) {
    return estimateName?.trim() ?? '';
  }
  return estimateName?.trim() || circuitName;
};
